import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ClientScansRouter } from "../modules/scans/scans.router";
import { DashboardLayout } from "../layouts/dashboard.layout";
import { ProtectedRoute } from "./protected-route";
import { Dashboard } from "../modules/dashboard";
import { NotFound } from "../modules/404";
import { ClientSitesRouter } from "../modules/sites/sites.router";
import { ClientProductsRouter } from "../modules/products/products.router";
import { ClientReferencesRouter } from "../modules/references/references.router";
import { CompareRouter } from "../modules/compare/compare.router";
import { FavoritesRouter } from "../modules/favorites/favorites.router";

export const ClientRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route element={<ProtectedRoute roles={["Any"]} />}>
            <Route path="/" element={<Dashboard />} />
          </Route>
          {ClientScansRouter}
          {ClientSitesRouter}
          {ClientProductsRouter}
          {ClientReferencesRouter}
          {CompareRouter}
          {FavoritesRouter}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
